import { render, staticRenderFns } from "./EndpointCard.vue?vue&type=template&id=61de60e6&scoped=true&lang=pug"
import script from "./EndpointCard.vue?vue&type=script&lang=js"
export * from "./EndpointCard.vue?vue&type=script&lang=js"
import style0 from "./EndpointCard.vue?vue&type=style&index=0&id=61de60e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61de60e6",
  null
  
)

export default component.exports